import { render, staticRenderFns } from "./CopyPublicLinkCell.vue?vue&type=template&id=0a866719&scoped=true&"
import script from "./CopyPublicLinkCell.vue?vue&type=script&lang=babel&"
export * from "./CopyPublicLinkCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a866719",
  null
  
)

export default component.exports